const LOGS_KEY = 'projectly_logs';
const MAX_LOGS = 500;

export function getLogs() {
  try { return JSON.parse(localStorage.getItem(LOGS_KEY) || '[]'); } catch { return []; }
}

export function addLog(entry) {
  try {
    const logs = getLogs();
    logs.unshift({ id: `log_${Date.now()}_${Math.random().toString(36).slice(2, 5)}`, timestamp: new Date().toISOString(), ...entry });
    if (logs.length > MAX_LOGS) logs.splice(MAX_LOGS);
    localStorage.setItem(LOGS_KEY, JSON.stringify(logs));
    window.dispatchEvent(new CustomEvent('projectly_logs_update'));
  } catch {}
}

export function clearLogs() {
  localStorage.removeItem(LOGS_KEY);
  window.dispatchEvent(new CustomEvent('projectly_logs_update'));
}
